import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Alert
} from "reactstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { getCookie } from "../jwt/_helpers";
import { getUser } from "../utils/getUser";
import { StateContext } from "../utils/context";
import { Redirect } from "react-router-dom";
import LoaderInner from "../components/LoaderInner";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const EscrowRequestRefund = ({
  id,
  refund_available,
  action,
}) => {
    const tokenAPI = getCookie("token");
    const { currentUser, setCurrentUser } = useContext(StateContext);
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);
    const [submissionInProgress, setSubmissionInProgress] = useState(false);
    const { forceUpdate, setForce } = action;

    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);

    const toggle = () => {
      if (!submissionInProgress) {
        setModalOpen(!modalOpen);
        setError(false);
      }
    };

    useEffect(() => {
      getUser(tokenAPI, currentUser, setCurrentUser);
    }, [success]);

    const submitRefundRequest = async () => {
        setSubmissionInProgress(true);
        try {
            const response = await axios.post(
              `${API_URL}escrow-request-refund/`,
              {
                payment_id: id,
              },
              {
                headers: {
                  "Authorization": `Bearer ${tokenAPI}`,
                  "x-api-key": X_API_KEY,
                  "Content-Type": "application/json",
                },
              }
            );

            if (response.status === 200) {
              setSuccess(true);
              setTimeout(() => {
                setModalOpen(false);
                setForce(forceUpdate + 1);
              }, 1000);
            } else {
              setError(true);
            }
        } catch (error) {
          setError(true);
        } finally {
          setSubmissionInProgress(false);
        }
    };

    if (!refund_available) {
      return <strong>{t("escrowWallet.view.escrowPayments.table.label.notAvailable")}</strong>;
    }

  return (
    <>
      <Button className="btn btn-outline-primary" onClick={toggle} disabled={submissionInProgress}>
        {submissionInProgress ? <Spinner size="sm" /> : t("escrowWallet.view.escrowPayments.table.button.requestRefund")}
      </Button>

      <LoaderInner show={submissionInProgress} />

      <Modal isOpen={modalOpen} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>
          {t("escrowWallet.view.escrowPayments.table.modal.requestRefund.header")}
        </ModalHeader>
        <ModalBody>
          <p>
            {t("escrowWallet.view.escrowPayments.table.modal.requestRefund.body.description")}
          </p> <br/>

          <strong>
            {t("escrowWallet.view.escrowPayments.table.modal.requestRefund.body.note")}
          </strong>

          <div className="mt-3">
            {error && (
              <Alert color="danger">
                {t("escrowWallet.view.escrowPayments.table.modal.requestRefund.message.error")}
              </Alert>
            )}
            {
              success && (
                <Alert color="success">
                  {t("escrowWallet.view.escrowPayments.table.modal.requestRefund.message.success")}
                </Alert>
              )
            }
          </div>
          {success ? <Redirect to="/e-wallet" /> : null}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle} disabled={submissionInProgress || success}>
            {t("escrowWallet.view.escrowPayments.table.modal.requestRefund.button.cancel")}
          </Button>
          <Button
            color="success"
            onClick={submitRefundRequest}
            disabled={submissionInProgress || success}
          >
            {t("escrowWallet.view.escrowPayments.table.modal.requestRefund.button.confirm")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default EscrowRequestRefund;